export const PORTAL_TITLE = "Capital One Travel Portal";
export const SELECT_ROOM_TITLE = "Select a room";

export const CALIFORNIA_BILL_644_CANCELLATION_TEXT = `This hotel is in California, therefore you are entitled to free cancellation without penalty for 24 hours after booking. If you choose to change or cancel this booking after this 24 hour window, you will not be refunded any of the payment.`;
